export const EmbedRoutes = [
  // Internal-only: the two-phone composite filmed for the check-in screencast.
  { path: 'screencast-checkin', lazy: () => import('./pages/embed.screencast-checkin'), },
]
